import { CartLinesUpdateEvent } from '@shopify/events';
import { CartItemsComponent } from '@theme/component-cart-items';
const money = cents => new Intl.NumberFormat('es-UY',{style:'currency',currency:'UYU',maximumFractionDigits: cents % 100 ? 2 : 0}).format(cents/100);
let adding = false;
class SanamCartExtras extends HTMLElement {
 connectedCallback() {
  const signature=this.dataset.total+'|'+this.querySelector('[data-extras-cart]')?.textContent;
  if(this._signature===signature && this.querySelector('.sanam-extras-grid')?.children.length) return;
  this._signature=signature;
  this.hidden=false;
  this.querySelector('.sanam-extras-grid')?.replaceChildren();
  try {
   const inCart=new Set(JSON.parse(this.querySelector('[data-extras-cart]').textContent));
   const pool=JSON.parse(this.querySelector('[data-extras-products]').textContent).filter(Boolean);
   const titles=JSON.parse(this.querySelector('[data-extras-titles]').textContent).join(' ').toLowerCase();
   const groups=['bts','stray kids','twice','blackpink','enhypen','txt','seventeen','boynextdoor','riize','tws','ateez','babymonster','nct','katseye','illit','le sserafim','exo','nexz'];
   const matches=groups.filter(g=>titles.includes(g));
   const products=new Map();
   for(const p of pool) if(!inCart.has(p.id)&&p.variants.length) {
    p.related=matches.some(g=>p.title.toLowerCase().includes(g));
    const existing=products.get(p.id);
    if(!existing || p.related) products.set(p.id,p);
   }
   const gap=Math.max(0,30000-Number(this.dataset.total));
   const candidates=[...products.values()].map(p=>({...p,price:Math.min(...p.variants.map(v=>v.price))}));
   candidates.sort((a,b)=> {
    if(a.related!==b.related) return a.related?-1:1;
    if(gap) {
     const fit=p=>p.variants.some(v=>v.price>=gap&&v.price<=gap+10000);
     if(fit(a)!==fit(b)) return fit(a)?-1:1;
    }
    return Number(b.related)-Number(a.related)||a.price-b.price;
   });
   const grid=this.querySelector('.sanam-extras-grid');
   for(const p of candidates.slice(0,4)) grid.append(this.card(p));
   if(!grid.children.length) this.hidden=true;
  } catch(error) { this.hidden=true; console.warn('No se pudieron mostrar las sugerencias',error); }
 }
 card(p) {
  const card=document.createElement('article'); card.className='sanam-extra';
  const link=document.createElement('a'); link.href=p.url;
  const img=document.createElement('img'); img.src=p.image; img.alt=p.title; img.loading='lazy'; img.width=160; img.height=160;
  const title=document.createElement('span'); title.className='sanam-extra-title'; title.textContent=p.title;
  link.append(img,title); card.append(link);
  const price=document.createElement('span'); price.className='sanam-extra-price'; card.append(price);
  const gap=Math.max(0,30000-Number(this.dataset.total));
  p.variants.sort((a,b)=>a.price-b.price);
  let variant=p.variants.find(v=>gap&&v.price>=gap)||p.variants[0];
  const update=()=>{price.textContent=money(variant.price);img.src=variant.image||p.image;};
  if(p.variants.length>1) {
   const select=document.createElement('select'); select.setAttribute('aria-label','Elegí la versión de '+p.title);
   for(const v of p.variants) {const o=document.createElement('option');o.value=String(v.id);o.textContent=v.title+' · '+money(v.price);o.selected=v.id===variant.id;select.append(o);}
   select.addEventListener('change',()=>{variant=p.variants.find(v=>String(v.id)===select.value);update();}); card.append(select);
  } else if(variant.title!=='Default Title') {const label=document.createElement('span');label.textContent=variant.title;label.style.fontSize='12px';card.append(label);}
  const button=document.createElement('button');button.type='button';button.textContent='+ Agregar';
  button.addEventListener('click',()=>this.add(variant,button));card.append(button);update();return card;
 }
 async add(variant,button) {
  if(adding) return; adding=true;
  const buttons=[...document.querySelectorAll('sanam-cart-extras button')];buttons.forEach(b=>b.disabled=true);
  const status=this.querySelector('.sanam-extras-status');status.textContent='Agregando a tu pedido…';button.textContent='Agregando…';
  let deferred;
  try {
   await Promise.all(CartItemsComponent.pendingQuantityUpdates);
   const sections=[...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el=>el.dataset.sectionId))].slice(0,5);
   const root=window.Shopify?.routes?.root||'/';
   deferred=CartLinesUpdateEvent.createPromise();
   document.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'cart',lines:[{id:String(variant.id),quantity:1}],promise:deferred.promise}));
   const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1}],sections,sections_url:location.pathname})});
   const result=await response.json();
   if(!response.ok||result.status) throw new Error(result.description||'No se pudo agregar. Revisá la disponibilidad e intentá nuevamente.');
   let cart;
   try {const res=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});if(res.ok)cart=await res.json();} catch {}
   deferred.resolve({cart:cart?CartLinesUpdateEvent.createCartFromAjaxResponse(cart):undefined,detail:{sections:result.sections,items:cart?.items||result.items,itemCount:cart?.item_count,source:'sanam-cart-extras',didError:false}});
   status.textContent='Agregado a tu pedido.';
  } catch(error) {
   deferred?.resolve({detail:{didError:true}});
   status.textContent=error.message||'Ocurrió un error. Intentá nuevamente.';
  } finally {adding=false;buttons.forEach(b=>b.disabled=false);button.textContent='+ Agregar';}
 }
}
if(!customElements.get('sanam-cart-extras')) customElements.define('sanam-cart-extras',SanamCartExtras);

let scheduled=false;
new MutationObserver(()=>{
 if(scheduled) return;
 scheduled=true;
 requestAnimationFrame(()=>{
  scheduled=false;
  document.querySelectorAll('sanam-cart-extras').forEach(el=>{
   const signature=el.dataset.total+'|'+el.querySelector('[data-extras-cart]')?.textContent;
   if(el.querySelector('[data-extras-products]') && (el._signature!==signature || (!el.hidden&&!el.querySelector('.sanam-extras-grid')?.children.length))) el.connectedCallback();
  });
 });
}).observe(document.body,{childList:true,subtree:true,characterData:true});
